import {Component, OnInit, ElementRef, ViewChild} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
})
export class PrivacyComponent implements OnInit {
  messages: any = []
  polling: any
  inputMessage: any = ''
  userData: any = JSON.parse(localStorage.getItem('logindata'))
  doctorData: any = {
    rating: 0
  }
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;

  constructor(private userSvc: AuthService, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.params.id) {
      this.listMessages()
      // this.getDoctorDetail()
      this.polling = setInterval(() => {
        this.listMessages()
      }, 2000);

    }

  }

  listMessages() {
    this.userSvc.listMessages(this.activatedRoute.snapshot.params.id).subscribe(res => {
      console.log(res)
      this.messages = res["data"]["message"]
      setTimeout(() => {
        this.scrollToBottom()

      }, 1000);
      this.doctorData.name = res["data"]["doctor"][0].name
      this.doctorData.profilePicture = res["data"]["doctor"][0]["profilePicture"]
      this.doctorData.id = res["data"]["doctor"][0]["_id"]
      this.doctorData.rating = res["data"]["doctor"][0]["averageRatings"]
      this.doctorData.review = res["data"]["doctor"][0]["review"].length
      this.doctorData.education = res["data"]["doctor"][0]["education"].slice(0, 2).join(',')
      this.doctorData.speciality = res["data"]["doctor"][0]["speciality"].slice(0, 2).join(',')

    }, error => {

    })
  }

  ngOnDestroy(): void {
    clearInterval(this.polling);
  }

  sendMessage() {
    console.log(this.activatedRoute.snapshot.params.id)
    this.userSvc.sendMessage(this.activatedRoute.snapshot.params.id, this.inputMessage).subscribe(res => {

      // this.messages.push(res["data"])
      this.listMessages()

      this.inputMessage = ''


    }, error => {
      console.log(error)
    })
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {
    }
  }

  parseInt(number) {
    return parseInt(number)
  }

  counter(i: number) {
    return new Array(i);
  }

}
